import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: false,name: 'duration'})

export class DurationPipe implements PipeTransform {
  transform(value: number): string {

    if (value != null) {
      const hours = Math.floor(value / 1000 / 60 / 60);
      const minutes = Math.floor(value / 1000 / 60) - (hours * 60);
      const seconds = Math.floor(value / 1000) - (hours * 60 * 60) - (minutes * 60);

      let duration = '';
      if (hours > 0) {
        duration = `${hours}h`;
      }
      if (minutes >= 0) {
        duration = `${duration} ${minutes}m`;
      }
      if (seconds >= 0) {
        duration = `${duration} ${seconds}s`;
      }
      return duration.trim();
    }
    return '0s';
  }
}
